import React from "react";
import { FiMail } from "react-icons/fi";

const SubmissionReceived = () => {
  return (
    <div className="bg-white p-8 md:p-10 rounded-lg shadow-[0_0_20px_rgba(0,0,0,0.1)] border-2 border-gray-200 w-full max-w-3xl font-inter text-center flex flex-col justify-center items-center min-h-[400px]">
      <div className="flex justify-center mb-6">
        <div className="bg-green-100 p-4 rounded-full">
          <FiMail className="h-12 w-12 text-green-600" />
        </div>
      </div>
      <h2 className="text-3xl font-bold text-black mb-3">
        Check your email to verify your submission and complete the process.
      </h2>
    </div>
  );
};

export default SubmissionReceived;
